import React from 'react';
export var EnvironmentContext = React.createContext({
    variables: {
        api: { host: '', schema: '' },
        apiInternal: { host: '', schema: '' },
        auth0: { tenantDomain: 'PLACEHOLDER_TENANT_DOMAIN', clientId: 'PLACEHOLDER_CLIENT_ID' },
        recaptcha: { siteKey: '' },
        appHost: '',
        isStripeProductionEnvironment: false,
    },
});
export var EnvironmentProvider = function (_a) {
    var variables = _a.variables, children = _a.children;
    return React.createElement(EnvironmentContext.Provider, { value: { variables: variables } }, children);
};
//# sourceMappingURL=environment.js.map